import { connect } from "react-redux";
import SEO from "@/components/SEO";
import { Link } from "react-router";
import { Link as MuiLink, Box, Typography } from "@mui/material";
import { withTranslation, WithTranslation } from "react-i18next";

interface NoMatchProps extends WithTranslation {
    userId?: number;
}

interface RootState {
    user: {
        get: (key: string) => any;
    };
}

const NoMatch = ({ userId, t }: NoMatchProps) => (
    <SEO title="404">
        <Box
            sx={{
                width: "100%",
                height: { xs: "calc(100vh - 60px)", sm: "calc(100vh - 65px)" },
                backgroundImage: 'url("/images/404_bg.png")',
                backgroundSize: "cover",
                backgroundPosition: "bottom left",
                backgroundRepeat: "no-repeat",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <Box
                sx={{
                    backgroundColor: "rgba(255, 255, 255, 0.5)",
                    textAlign: "center",
                    margin: "10px auto",
                    padding: "20px",
                    borderRadius: "8px",
                }}
            >
                <Typography variant="h2" component="h2" align="center" gutterBottom>
                    {t("NoMatchTitle")}
                </Typography>
                <Typography variant="body1" sx={{ fontSize: "1.2em" }}>
                    {t("LittleLostPhrase")}
                    <br />
                    {userId ? (
                        <span>
                            {t("Go")}{" "}
                            <MuiLink
                                underline="hover"
                                onClick={() => window.history.back()}
                            >
                                {t("back")}
                            </MuiLink>{" "}
                            {t("or")} {t("homeToYour")}{" "}
                            <MuiLink component={Link} to={`/profile/${userId}`} underline="hover">
                                {t("profile")}
                            </MuiLink>
                            .
                        </span>
                    ) : (
                        <span>
                            {t("Go")}{" "}
                            <MuiLink underline="hover"
                                onClick={() => window.history.back()}
                            >
                                {t("back")}
                            </MuiLink>{" "}
                            {t("or")}{" "}
                            <MuiLink component={Link} to="/" underline="hover">
                                {t("home")}
                            </MuiLink>
                            .
                        </span>
                    )}
                </Typography>
            </Box>
            <Box
                sx={{
                    marginTop: "15%",
                    marginLeft: "auto",
                    padding: "30px",
                }}
            >
                <Typography
                    variant="body1"
                    sx={{
                        fontSize: { xs: "0.9em", sm: "1em" },
                        marginBottom: "0.3em",
                    }}
                >
                    &quot;{t("Explore")}&quot; {t("theySay")}
                </Typography>
                <Typography
                    variant="body1"
                    sx={{
                        fontSize: { xs: "0.9em", sm: "1em" },
                        marginBottom: "0.3em",
                    }}
                >
                    &quot;{t("ItWillBeFun")}&quot; {t("theySay")}
                </Typography>
            </Box>
        </Box>
    </SEO>
);

function mapStateToProps(state: RootState) {
    const { user } = state;
    const userId = user.get("id");
    return {
        userId,
    };
}

export default withTranslation(["translation.utils"])(
    connect(mapStateToProps)(NoMatch)
);
